import { render, staticRenderFns } from "./zhgl-list.vue?vue&type=template&id=d8dd5304&"
import script from "./zhgl-list.vue?vue&type=script&lang=ts&"
export * from "./zhgl-list.vue?vue&type=script&lang=ts&"
import style0 from "./zhgl-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports